<template>
  <base-section
    id="studentwrapper"
    :space="0"
  >
    <v-container>
      <div>
        <v-tabs
          id="tab-studentwrapper"
        >
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-activities`"
            @click="goToTop"
            id="student-activities"
          >
            Student Activities
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-bspa`"
            @click="goToTop"
            id="bspa"
          >
            Best Student Presentation Award
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-phdforum`"
            @click="goToTop"
            id="student-phd-forum"
          >
            PhD Forum
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-mcclunskey`"
            @click="goToTop"
            id="mccluskey"
          >
            McCluskey Award
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            to="test-spring-school"
            @click="goToTop"
            id="tss"
          >
            Test Spring School
          </v-tab>
          <v-tab
            class="font-weight-bold"
            min-width="96"
            text
            :href="`#tab-ets22`"
            @click="goToTop"
          >
            Student Activities ETS22
          </v-tab>
          <v-tab-item
            :value="`tab-activities`"
          >
            <student-activities />
          </v-tab-item>
          <v-tab-item
            :value="`tab-bspa`"
          >
            <bspa />
          </v-tab-item>
          <v-tab-item
            :value="`tab-phdforum`"
          >
            <student-phd-forum />
          </v-tab-item>
          <v-tab-item
            :value="`tab-mcclunskey`"
          >
            <mccluskey />
          </v-tab-item>
          <v-tab-item
            :value="`tab-tss`"
          >
            <tss />
          </v-tab-item>
          <v-tab-item
            :value="`tab-ets22`"
          >
            <student-activities-22 />
          </v-tab-item>
        </v-tabs>
      </div>
    </v-container>
  </base-section>
</template>
<script>
  import PhdForum from './PhdForum.vue'
  import PhdContest from './PhdContest.vue'
  import Bspa from './Bspa.vue'
  import StudentActivities from './StudentActivities.vue'
  import StudentPhdForum from './StudentPhdForum.vue'
  import Mccluskey from './Mccluskey.vue'
  import Tss from './Tss.vue'
  import StudentActivities22 from './StudentActivities22.vue'
  export default {
    name: 'StudentWrapper',
    components: { StudentActivities, PhdForum, PhdContest, Bspa, StudentPhdForum, Mccluskey, Tss, StudentActivities22 },

    data: () => ({
      tab: null,
      items: [
        'Student Activities',
        'Best Student Presentation Award',
        'PhD Forum',
        'McClunskey Award',
      ],
    }),
    mounted () {
      document.getElementById('tab-studentwrapper').firstChild.style = 'position: fixed; background-color: #fafafa !important; width = 100%; margin-top: -11px; z-index: 5; width: 100%;'
    },
    methods: {
      goToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      },
    },
  }
</script>
